export const typesSJPBReview = {
    GET_SJPBREVIEW_SUCCESS:'GET_SJPBREVIEW_SUCCESS',
    GET_SJPBREVIEW_ERROR:'GET_SJPBREVIEW_ERROR',
    GET_SJPBREVIEW_BEGIN:'GET_SJPBREVIEW_BEGIN',
    SJPBCREATE_ADDRESS: 'SJPBRESERVATIONS_PRIMARY_ADDRESS',

    SJPBRESERVATIONS_PRIMARY_ADDRESS:'SJPBRESERVATIONS_PRIMARY_ADDRESS',

    GET_SJPBPRICEANDTAX_SUCCESS:'GET_SJPBPRICEANDTAX_SUCCESS',
    GET_SJPBPRICEANDTAX_ERROR:'GET_SJPBPRICEANDTAX_ERROR',
    GET_SJPBPRICEANDTAX_BEGIN:'GET_SJPBPRICEANDTAX_BEGIN',
    RESET_SJPBPRICEANDTAX_INIT: 'RESET_SJPBPRICEANDTAX_INIT'
}
